import type { IssueType, SummaryItem } from '@/components/analysis/summary/types/triage'
import {
	type ImprovementStatusGetter,
	isOpenImprovementStatus,
} from '@/components/bpmn/improvements/mapImprovementsToElements'

export type ImprovementBadgeChoice =
	| { kind: 'open'; type: IssueType; extraCount: number; primary: SummaryItem }
	| { kind: 'addressed'; primary: SummaryItem }
	| null

/**
 * Pick the canvas badge for items already sorted by severity, then step number.
 * Open items win; if every remaining item is addressed, show the check badge.
 */
export function chooseImprovementBadge(
	items: SummaryItem[],
	getStatus: ImprovementStatusGetter
): ImprovementBadgeChoice {
	const open = items.filter((item) => isOpenImprovementStatus(getStatus(item)))
	if (open.length > 0) {
		const primary = open[0]
		if (!primary) return null
		return {
			kind: 'open',
			type: primary.type ?? 'question',
			extraCount: open.length - 1,
			primary,
		}
	}
	const addressed = items.filter((item) => getStatus(item) === 'addressed')
	const primary = addressed[0]
	if (!primary) return null
	return { kind: 'addressed', primary }
}

export function openImprovementsOnElement(
	items: SummaryItem[],
	getStatus: ImprovementStatusGetter
): SummaryItem[] {
	return items.filter((item) => isOpenImprovementStatus(getStatus(item)))
}
